import {Selectable} from '../../../../core/interfaces/selectable.interface';

export class VehicleStorage implements Selectable<VehicleStorage> {
  constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly address: string
  ) {
  }

  get value(): this {
    return this
  }

  get displayName(): string {
    return this.name;
  }

  toSelectText(): string {
    return this.name;
  }

  toSelectDescription(): string {
    return `Wybrano magazyn: ${this.name}`;
  }
}
